import {
  BD_GET_SUPPLIERNAME_LISTING,
  BD_GET_SUPPLIERNAME_LISTING_SUCCESS,
  BD_GET_SUPPLIERNAME_LISTING_FAILED,
  } from "./actionTypes"
  
  export const bdSupplierNameListing = () => {
    return {
      type: BD_GET_SUPPLIERNAME_LISTING,
    }
  }
  
  export const bdSupplierNameListingSuccess = bdSupplierName => {
    return {
      type: BD_GET_SUPPLIERNAME_LISTING_SUCCESS,
      payload: bdSupplierName,
    }
  }
  
  export const bdSupplierNameListingFail = error => {
    return {
      type: BD_GET_SUPPLIERNAME_LISTING_FAILED,
      payload: error,
    }
  }
  